import { render, staticRenderFns } from "./PurchaseInStock.vue?vue&type=template&id=7c386a4e&scoped=true&"
import script from "./PurchaseInStock.vue?vue&type=script&lang=js&"
export * from "./PurchaseInStock.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInStock.vue?vue&type=style&index=0&id=7c386a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c386a4e",
  null
  
)

export default component.exports